import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function SubHeading(props) {
  return (
    <p className={`${style.sliderHeader} ${props.className} `}>
      {props.text}
    </p>
  );
}

SubHeading.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * text to be displayed in header
   */
  text: PropTypes.string,
};
